module.exports = __webpack_public_path__ + "dingbeauty-landing/img/logo.fceeee09.svg";